import React from 'react';
import { useTranslation } from 'react-i18next';
import Typography from '../StyledTypography';
import ExportRequestsButton from './ExportRequestsButton';

/** "Requests" title with the Excel export button beside it. */
const RequestsPageHeader = ({ title }) => {
  const { t } = useTranslation();
  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        gap: 16,
        padding: '8px 0 12px',
      }}
    >
      <Typography variant="title2">{title || t('requests')}</Typography>
      <ExportRequestsButton />
    </div>
  );
};

export default RequestsPageHeader;
